// extracted by mini-css-extract-plugin
export default {"modal":"ModalHow_modal__0XFf7","header":"ModalHow_header__2RHjt","logoLink":"ModalHow_logoLink__2Vy6d","iconClose":"ModalHow_iconClose__9PkZY","content":"ModalHow_content__z5Ck9"};